/* eslint-disable react/prop-types */
import React from 'react'
import {
  Edit, SimpleForm, TextInput, required, SelectInput, Toolbar, SaveButton, Button,
} from 'react-admin'
import config from '../../config/config'

// Removes the delete button
const ClubEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)

const ClubEdit = (props) => (
  <Edit {...props}>
    <SimpleForm toolbar={<ClubEditToolbar />}>
      <TextInput disabled source="code" label="Code" validate={required()} />
      <TextInput disabled source="name" label="Nom" />
      <TextInput disabled source="league" label="Ligue" />
      <SelectInput
        source="status"
        label="Statut demande d'inscription"
        choices={[
          { id: 'hidden', name: 'Refusé' },
          { id: 'displayed', name: 'Accepté' },
          { id: 'pending', name: 'En attente' },
        ]}
      />
      <TextInput disabled source="committee" label="Nom du comité" />
      <TextInput disabled source="contactLastName" label="Nom du correspondant" />
      <TextInput disabled source="contactFirstName" label="Prénom du correspondant" />
      <TextInput disabled source="contactOfficePhone" label="Téléphone du correspondant" />
      <TextInput disabled source="contactCellPhone" label="Autre téléphone du correspondant" />
      <TextInput disabled source="contactEmail" label="Email du correspondant" />
      <a href={`${config.publicWebsiteUrl}/edition-club/${props.id}`} target="_blank" rel="noreferrer">
        <Button label="Modifier l'inscription" />
      </a>
    </SimpleForm>
  </Edit>
)

export default ClubEdit
